import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { Map } from 'immutable';
import { bundle } from '../../../helpers';
import { I18nContext } from './I18nContext';
import { fetchTranslations } from '../../../apis/core/translations';
export var I18nProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(I18nProvider, _React$Component);

  var _super = _createSuper(I18nProvider);

  function I18nProvider(props) {
    var _this;

    _classCallCheck(this, I18nProvider);

    _this = _super.call(this, props);

    _this.populateBundleTranslations = function (locale) {
      bundle.config.translations = _objectSpread(_objectSpread({}, bundle.config.translations), _this.state.translations.get(locale).toJS());
      bundle.config.translationsLocale = locale;
    };

    _this.loadTranslations = function (locale, context, isPublic) {
      if (!_this.loading.hasIn([locale, context])) {
        _this.loading = _this.loading.setIn([locale, context], true); // check to see if the translation context was already loaded by the CE
        // client-side code (like if K.load is used in a form event)

        fetchTranslations({
          cache: true,
          contextName: context,
          localeCode: locale,
          "public": isPublic
        }).then(function (_ref) {
          var error = _ref.error,
              entries = _ref.entries;

          if (entries) {
            _this.setState(function (state) {
              return {
                translations: state.translations.setIn([locale, context], Map(entries.map(function (entry) {
                  return [entry.key, entry.value];
                })))
              };
            });
          } else {
            _this.setState(function (state) {
              return {
                translations: state.translations.setIn([locale, context], Map())
              };
            });
          }
        });
      } else if (locale !== bundle.config.translationsLocale && _this.state.translations.has(locale)) {
        // If the context is already loaded for the locale but we're loading due
        // to the locale changing then we need to populate the bundle's
        // translation config from the already-loaded translations.
        _this.populateBundleTranslations(locale);
      }
    };

    _this.state = {
      translations: Map()
    };
    _this.loading = Map(); // this effectively enables translations for the CE client-side code

    bundle.config = bundle.config || {};
    bundle.config.translations = bundle.config.translations || {};
    bundle.config.translationsLocale = props.locale;
    return _this;
  }

  _createClass(I18nProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.locale) {
        this.loadTranslations(this.props.locale, 'shared', true);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.locale !== this.props.locale) {
        this.loadTranslations(this.props.locale, 'shared', true);
      }

      if (!this.state.translations.equals(prevState.translations) && this.state.translations.get(this.props.locale) && bundle.config) {
        this.populateBundleTranslations(this.props.locale);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.translations) {
        return /*#__PURE__*/React.createElement(I18nContext.Provider, {
          value: {
            context: this.props.context || 'shared',
            locale: this.props.locale || 'en',
            translations: this.state.translations,
            loadTranslations: this.loadTranslations
          }
        }, this.props.children);
      } else {
        return null;
      }
    }
  }]);

  return I18nProvider;
}(React.Component);